import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

@observer
export default class Alert extends React.Component {

  static propTypes = {
    type: PropTypes.oneOf(['SUCCESS', 'ERROR']),
    text: PropTypes.string,
    duration: PropTypes.number,
    onHide: PropTypes.func
  }

  static defaultProps = {
    type: 'SUCCESS',
    duration: 0, // set any duration above 0 to auto-timeout.
    onHide: () => {}
  }


  componentWillUnmount(){
    this.hideAlert();
  }

  delayedHide = (duration) => {
    if(duration){
      setTimeout(() => {
        this.hideAlert();
      }, duration);
    }
  }

  hideAlert = () => {
    this.props.onHide();
  }

  renderAlert = () => {
    this.delayedHide(this.props.duration);
    const label = this.props.type === 'SUCCESS' ? 'Success! ' : 'Error: ';
    return (
      <div aria-hidden className={`alert alert-${this.props.type.toLowerCase()}`}>
          <button type="button" className="close_btn icon-close" onClick={this.hideAlert}>
            <span className="sr-only">Close alert</span>
          </button>
          <p><strong>{label}</strong>{this.props.text}</p>
        </div>
    )
  }

  render () {
    return (
      <div className="alert-bars">
        {/* Screen reader section should always be present, not conditionally
        rendered, to allow aria to manage changes appropriately. */}
        <p className="sr-only" role="alert" aria-live="assertive" aria-atomic="true">
          {`${this.props.type}:  ${this.props.text}`}
        </p>
        {this.props.text &&
          this.renderAlert()
        }
      </div>
    )
  }
}
